import React, { useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteGallery,
  detailGallery,
  listGallery,
} from "../redux/actions/galleryAction";
import { url } from "../utils/env";
import { Link } from "react-router-dom";

const GalleryScreen = () => {
  const dispatch = useDispatch();
  const listGalleryState = useSelector((state) => state.listGallery);
  const { gallerys } = listGalleryState;
  const galleryDelete = useSelector((state) => state.galleryDelete);
  const { success } = galleryDelete;
  useEffect(() => {
    dispatch(listGallery());
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Gallery" button="Add New Image" link="/add-gallery" />
      {gallerys &&
        gallerys.map((value) => (
          <>
            <div class="card">
              <div class="card-body">
                <div style={{ marginBottom: "9px" }}>
                  <div class="row align-items-center">
                    <div class="col-md-8">
                      <h2 class="page-title">{value.title}</h2>
                    </div>
                    <div class="col-md-4">
                      <div class="float-end d-none d-md-block">
                        <Link
                          to={`/edit-gallery/${value.uuid}`}
                          onClick={() => dispatch(detailGallery(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </Link>
                        <button
                          style={{
                            marginLeft: "5px",
                            backgroundColor: "red",
                            color: "#fff",
                          }}
                          onClick={() => dispatch(deleteGallery(value.uuid))}
                          class="btn btn-secondary btn-sm edit"
                          title="Edit"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {JSON.parse(value.imageArray).map((data) => (
                    <div className="col-xl-3 col-md-6">
                      <a
                        href="assets/images/gallery/work-1.jpg"
                        className="gallery-popup"
                        title="Open Imagination"
                      >
                        <div className="project-item">
                          <div className="overlay-container">
                            <img
                              src={`${url}/${data.path}`}
                              alt="img"
                              className="gallery-thumb-img"
                              style={{ height: "250px", objectFit: "cover" }}
                            />
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ))}
    </Layout>
  );
};

export default GalleryScreen;
